import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateCreditReviewToCompleteMutation = (creditReviewId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			return creditReviewDetailsService.updateCreditReviewToComplete(
				creditReviewId,
			);
		},
		{
			onSuccess(_result) {},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateCreditReviewToCompleteMutation;
